import { useAuth } from '@/hooks';
import Grid2 from '@mui/material/Grid2';
import { Navigate } from 'react-router-dom';
import SignInPage from './sign_in';

const Login = () => {
  const auth = useAuth();
  if (auth.token) return <Navigate to="/portal" replace />;

  return (
    <Grid2 container>
      <SignInPage />
    </Grid2>
  );
};
export default Login;
